import type { ReactElement, ReactNode, ChangeEvent } from 'react';
import { Component as CheckIcon } from 'icons/icon-ui--check.svg';

type Props = {
  id: string;
  label: ReactNode;
  ariaLabel?: string;
  checked?: boolean;
  disabled?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
};

function Checkbox({
  id,
  label,
  ariaLabel,
  checked,
  disabled,
  onChange,
}: Props): ReactElement {
  return (
    <div className="c-input-checkbox">
      <label
        htmlFor={id}
      >
        <input
          id={id}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          aria-label={ariaLabel}
          onChange={onChange}
        />
        {label}
        <span className="c-input-custom">
          <CheckIcon
            width="13"
            height="13"
            className="c-input-custom__icon c-svg-fill-white-color"
          />
        </span>
      </label>
    </div>
  );
}

export default Checkbox;
